import {
  ApiInitialSurveyQuestion,
  InitialSurveyQuestion,
} from "../../data/slices/initialsurvey/interface";

/**
 * Maps the API response format to the format expected by the InitialSurveyContainer component
 */
export const initialSurveyMapper = (
  questions: ApiInitialSurveyQuestion[],
): InitialSurveyQuestion[] => {
  if (!questions || !Array.isArray(questions)) {
    return [];
  }

  return questions.map((question) => ({
    id: question.Id,
    questionText: question.QuestionText,
    type: question.type.charAt(0).toUpperCase() + question.type.slice(1), // Capitalize first letter
    emoji: false, // Since the new API doesn't have emoji information, default to false
    answers: question.Answers.map((answer) => ({
      id: answer.id,
      text: answer.text,
      // No emoji in the new API structure
    })),
  }));
};
